import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconMoreStyle0 = cosmosIconCss;

const CosmosIconMore$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconMore extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '0af08ce29bbb0cec836966668d971d5c5473b39d', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '9b40c70d9ecd520e132214c3e0cad9a2dae2bf71', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '6f119893491b55c1e78afdbed2224bc5c26d6643', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M4.001 10.979a1.52 1.52 0 0 1 3.04 0 1.466 1.466 0 0 1-1.52 1.52 1.466 1.466 0 0 1-1.52-1.52Zm5.48 0a1.52 1.52 0 1 1 3.04 0 1.52 1.52 0 0 1-3.04 0Zm6.999-1.52a1.52 1.52 0 1 0 0 3.04 1.52 1.52 0 0 0 0-3.04Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconMoreStyle0; }
}, [1, "cosmos-icon-more", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-more"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-more":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconMore$1);
            }
            break;
    } });
}

const CosmosIconMore = CosmosIconMore$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconMore, defineCustomElement };
